import "core-js/stable";
import "regenerator-runtime/runtime";
import ScrollOut from "scroll-out";

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

import objectFitImages from 'object-fit-images';
objectFitImages();

import './_scroll-out.js';
import './_modal.js';
import './_swiper.js';
import './_spacer.js';
import './_focus.js';
import { toggleBodyClass } from './_class/_toggle';

document.querySelector('.menu-icon__wrap').addEventListener('click', toggleBodyClass('menu-open'));
document.querySelector('.close-icon__wrap').addEventListener('click', toggleBodyClass('menu-open'));
// document.querySelector('.sitemap').addEventListener('click', toggleBodyClass('menu-open'));
